<template>
  <div class="live-item-player row-nowrap">
    <div class="flex-1" />

    <div class="livesBody">
      <div class="row-nowrap">
        <div class="flex-3">
          <div class="player-elements">
            <tcplayer v-if="loaded" id="player" :source="m3u8" :cover="liveInfo.cover"
              :autoplay="liveInfo.status == 'LIVE'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import tcplayer from "@/components/tcplayer";
import { getResourceLivesDetail } from "@/utils/request.js";

export default {
  components: {
    tcplayer,
  },
  props: ["id", "getType"],
  data() {
    return {
      liveId: "",
      liveInfo: {},
      loaded: false,
      m3u8: "",
      countTimer: 0,
      countTime: 0,
      comments: [],
      type: "TO_LIVE",
      websocket: null,
      showBarrage: true,
    };
  },
  mounted() {
    this.liveId = this.$props.id + "";
    if (this.getType == "live") {
      this.queryLive(this.liveId);
    } else if (this.getType == "video") {
      this.queryvideo(this.liveId);
    }
    if (this.liveInfo.status == "RESERVATION") {
      this.setCountTImer();
    }
    // this.loaded = true;
  },
  destroyed() {
    window.clearInterval(this.countTimer);
    this.countTimer = 0;
  },
  methods: {
    // 查询直播
    queryLive(liveId) {
      getResourceLivesDetail(liveId).then((res) => {
        this.liveInfo = res.data
        switch (this.liveInfo.status) {
          case "RESERVATION":
            this.m3u8 = "";
            this.countTime = this.liveInfo.countdown;
            this.setCountTImer();
            break;
          case "LIVE":
            this.m3u8 = this.liveInfo.m3u8;
            break;
          case "LOOK_BACK":
            if (this.liveInfo.lookBacks.length > 0) {
              let arr = this.liveInfo.lookBacks.filter((_) => _.autoplay);
              if (arr.length > 0) {
                this.m3u8 = arr[0].url;
              } else {
                this.m3u8 = this.liveInfo.lookBacks[0].url;
              }
            }
            break;
        }
      })
      this.loaded = true;
      
    },
    queryvideo(liveId) {
      getResourceVideosDetail(liveId).then((res) => {
        if (res.data) {
          this.liveInfo = res.data;
          this.m3u8 = res.data.url;
        }
        setTimeout(() => {
          this.loaded = true;
        }, 0)
      });
    },
    setCountTImer() {
      this.countTimer = clearInterval(() => {
        if (this.countTime === 0) {
          this.queryLive(this.liveId);
          window.clearInterval(this.countTimer);
        } else {
          this.countTime = this.countTime - 1;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.live-item-player {
  .livesBody {
    width: 100%;

    //播放器/文字弹幕/礼物弹幕
    .player-elements {
      position: relative;
    }

    //直播推荐
    .recommend {
      margin-top: 2rem;
    }
  }
}
</style>
